"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationArrowButton = exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = require("@instructure/ui-buttons/lib/IconButton");

var _PresentationContent = require("@instructure/ui-a11y-content/lib/PresentationContent");

var _Tooltip = require("@instructure/ui-tooltip/lib/Tooltip");

var _IconArrowOpenStartSolid = require("@instructure/ui-icons/lib/IconArrowOpenStartSolid");

var _IconArrowOpenEndSolid = require("@instructure/ui-icons/lib/IconArrowOpenEndSolid");

var _testable = require("@instructure/ui-testable/lib/testable.js");

var _dec, _class, _class2, _temp;

/**
---
parent: Pagination
id: Pagination.Navigation
---
**/
var PaginationArrowButton = (_dec = (0, _testable.testable)(), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PaginationArrowButton, _Component);

  var _super = (0, _createSuper2.default)(PaginationArrowButton);

  function PaginationArrowButton() {
    (0, _classCallCheck2.default)(this, PaginationArrowButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PaginationArrowButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          direction = _this$props.direction,
          buttonRef = _this$props.buttonRef,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["label", "direction", "buttonRef"]);
      var Icon = direction === 'prev' ? _IconArrowOpenStartSolid.IconArrowOpenStartSolid : _IconArrowOpenEndSolid.IconArrowOpenEndSolid;
      return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
        on: ['hover', 'focus'],
        renderTip: /*#__PURE__*/_react.default.createElement(_PresentationContent.PresentationContent, null, label)
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, props, {
        size: "small",
        withBackground: false,
        withBorder: false,
        screenReaderLabel: label,
        rel: props.href || props.to ? direction : null,
        elementRef: buttonRef
      }), Icon));
    }
  }]);
  PaginationArrowButton.displayName = "PaginationArrowButton";
  return PaginationArrowButton;
}(_react.Component), _class2.propTypes = {
  direction: _propTypes.default.oneOf(['next', 'prev']),
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  buttonRef: _propTypes.default.func
}, _class2.defaultProps = {
  direction: void 0,
  buttonRef: function buttonRef(el) {}
}, _temp)) || _class);
exports.PaginationArrowButton = PaginationArrowButton;
var _default = PaginationArrowButton;
exports.default = _default;